// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"c61c6059","453":"c1f4b08a","651":"2a6e8e36"}[chunkId] + ".chunk.js";
};